import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["choice", "price"]

  connect() {
    this.update()
  }

  update() {
    const frequency = this.choiceTargets.find(choice => choice.checked).value
    this.priceTargets.forEach(price => {
      price.hidden = price.dataset.billingFrequency !== frequency
    })
  }
}
